<template>
  <div>
    <p v-if="availableUntilFundIsExhausted" class="mt-3">
      <b>{{ title }}:</b>
      {{ formatDate(requestStartDate) }} - a keret kimerüléséig
    </p>
    <p v-if="!availableUntilFundIsExhausted" class="mt-3">
      <b>{{ title }}:</b>
      {{ formatDate(requestStartDate) }} - {{ formatDate(requestEndDate) }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    requestStartDate: {
      type: String,
      required: true
    },
    requestEndDate: {
      type: String,
      required: true
    },
    availableUntilFundIsExhausted: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  methods: {
    formatDate: function(date) {
      if (!date) {
        return ''
      }
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('.')
    }
  }
}
</script>

<style lang="scss" scoped></style>
